// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27none%27 viewBox=%270 0 20 20%27%3e%3cpath stroke=%27%236b7280%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%271.5%27 d=%27m6 8 4 4 4-4%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.saplan-form-container {
  min-height: calc(100vh - 118px);
  background: var(--grey-shade-three);
  padding: 2rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
@media (max-width: 768px) {
  .saplan-form-container {
    padding: 1rem;
  }
}
.saplan-form-container .no-spinner::-webkit-outer-spin-button,
.saplan-form-container .no-spinner::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.saplan-form-container .toast {
  position: fixed;
  top: 1rem;
  right: 1rem;
  padding: 0.75rem 1rem;
  border-radius: 0.375rem;
  color: white;
  font-weight: 500;
  z-index: 1000;
  animation: toast-slide-in 0.3s ease-out;
}
.saplan-form-container .toast.success {
  background-color: #10b981;
}
.saplan-form-container .toast.error {
  background-color: #ef4444;
}
.saplan-form-container .saplan-form-wrapper {
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 1.5rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  animation: plan-form-fade-in 0.3s ease-out;
  width: 70%;
}
@media (max-width: 768px) {
  .saplan-form-container .saplan-form-wrapper {
    padding: 1rem;
    width: 100%;
  }
}
.saplan-form-container .saplan-form-header {
  text-align: center;
  margin-bottom: 0.5rem;
}
.saplan-form-container .saplan-form-header .saplan-form-title {
  font-size: 1.6rem;
  font-weight: 500;
  color: #374151;
  margin: 0;
}
@media (max-width: 768px) {
  .saplan-form-container .saplan-form-header .saplan-form-title {
    font-size: 1.25rem;
  }
}
.saplan-form-container .saplan-form-divider {
  border: none;
  border-top: 1px solid #e5e7eb;
  margin: 1.5rem 0;
}
.saplan-form-container form {
  padding: 0;
  background: transparent;
  border: none;
  box-shadow: none;
  animation: none;
  width: 100%;
}
@media (max-width: 768px) {
  .saplan-form-container form {
    padding: 0;
    width: 100%;
  }
}
.saplan-form-container > h1 {
  display: none;
}
.saplan-form-container .form-section {
  padding-bottom: 1.5rem;
}
.saplan-form-container .form-section:last-of-type {
  border-bottom: none;
  margin-bottom: 0;
  padding-bottom: 0;
}
.saplan-form-container .form-section h3 {
  font-size: 1.125rem;
  font-weight: 500;
  color: #374151;
  margin: 0 0 1rem 0;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid #e5e7eb;
}
.saplan-form-container .form-row {
  display: flex;
  gap: 1rem;
  margin-bottom: 1rem;
}
.saplan-form-container .form-row:last-child {
  margin-bottom: 0;
}
@media (max-width: 768px) {
  .saplan-form-container .form-row {
    flex-direction: column;
    gap: 0.5rem;
  }
}
.saplan-form-container .form-group {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  margin-bottom: 0rem;
}
.saplan-form-container .form-group:last-child {
  margin-bottom: 0;
}
.saplan-form-container .form-group label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 500;
  font-size: 0.875rem;
  color: #374151;
}
.saplan-form-container .form-group label .saplan-form-required {
  color: #ef4444;
  margin-left: 0.25rem;
}
.saplan-form-container .form-group input,
.saplan-form-container .form-group select,
.saplan-form-container .form-group textarea {
  width: 100%;
  padding: 0.5rem;
  border: 1px solid #d1d5db;
  border-radius: 0.25rem;
  font-size: 0.875rem;
  font-family: inherit;
  color: #374151;
  background: #ffffff;
  box-sizing: border-box;
  min-height: 2.5rem;
}
.saplan-form-container .form-group input:focus,
.saplan-form-container .form-group select:focus,
.saplan-form-container .form-group textarea:focus {
  outline: none;
  border-color: var(--primary-color, #3b82f6);
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}
.saplan-form-container .form-group input:hover:not(:focus),
.saplan-form-container .form-group select:hover:not(:focus),
.saplan-form-container .form-group textarea:hover:not(:focus) {
  border-color: #9ca3af;
}
.saplan-form-container .form-group input::placeholder,
.saplan-form-container .form-group select::placeholder,
.saplan-form-container .form-group textarea::placeholder {
  color: #9ca3af;
}
.saplan-form-container .form-group input:disabled,
.saplan-form-container .form-group select:disabled,
.saplan-form-container .form-group textarea:disabled {
  background-color: #f9fafb;
  color: #6b7280;
  cursor: not-allowed;
}
.saplan-form-container .form-group select {
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: right 0.5rem center;
  background-repeat: no-repeat;
  background-size: 1.5rem 1.5rem;
  padding-right: 2.5rem;
}
.saplan-form-container .form-group textarea {
  min-height: 100px;
  resize: vertical;
  padding: 0.5rem;
}
.saplan-form-container .form-group .error {
  color: #ef4444;
  font-size: 0.75rem;
  margin-top: 0.25rem;
  font-weight: 500;
}
.saplan-form-container .rights-checkboxes {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  gap: 1rem;
  margin-top: 1rem;
}
@media (max-width: 768px) {
  .saplan-form-container .rights-checkboxes {
    grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
    gap: 0.75rem;
  }
}
.saplan-form-container .checkbox-group {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}
.saplan-form-container .checkbox-group label {
  font-size: 0.875rem;
  font-weight: 500;
  color: #374151;
  text-transform: capitalize;
  margin-bottom: 0;
  cursor: pointer;
}
.saplan-form-container .checkbox-group input[type=checkbox] {
  appearance: none;
  width: 50px;
  height: 24px;
  background-color: #d1d5db;
  border: none;
  border-radius: 24px;
  position: relative;
  cursor: pointer;
  transition: all 0.3s ease;
  min-height: 24px;
}
.saplan-form-container .checkbox-group input[type=checkbox]::before {
  content: "";
  position: absolute;
  height: 18px;
  width: 18px;
  left: 3px;
  top: 3px;
  background-color: white;
  border-radius: 50%;
  transition: all 0.3s ease;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
}
.saplan-form-container .checkbox-group input[type=checkbox]:checked {
  background-color: var(--primary-color, #3b82f6);
}
.saplan-form-container .checkbox-group input[type=checkbox]:checked::before {
  transform: translateX(26px);
}
.saplan-form-container .checkbox-group input[type=checkbox]:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}
.saplan-form-container .checkbox-group input[type=checkbox]:hover:not(:checked) {
  background-color: #9ca3af;
}
.saplan-form-container .checkbox-group input[type=checkbox]:hover:checked {
  background-color: #2563eb;
}
.saplan-form-container button[type=submit] {
  width: 100%;
  padding: 0.75rem 1.5rem;
  background-color: var(--primary-color);
  color: white;
  border: none;
  border-radius: 0.375rem;
  font-weight: 500;
  font-size: 0.875rem;
  cursor: pointer;
  transition: all 0.2s ease;
  margin-top: 1.5rem;
  min-height: 2.75rem;
}
.saplan-form-container button[type=submit]:focus {
  outline: none;
}
.saplan-form-container button[type=submit]:hover {
  background-color: #005a9a;
}
.saplan-form-container button[type=submit]:disabled {
  background-color: #d1d5db;
  color: #9ca3af;
  cursor: not-allowed;
  opacity: 0.6;
}
@media (max-width: 768px) {
  .saplan-form-container button[type=submit] {
    padding: 0.625rem 1.25rem;
    font-size: 0.8125rem;
  }
}
.saplan-form-container .loading {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 200px;
  font-size: 1.125rem;
  color: #6b7280;
}

@keyframes plan-form-fade-in {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes toast-slide-in {
  from {
    opacity: 0;
    transform: translateX(100%);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}
@media (max-width: 768px) {
  .saplan-form-container .saplan-form-wrapper {
    width: 100%;
  }
}
@media (max-width: 480px) {
  .saplan-form-container {
    padding: 0.5rem;
  }
  .saplan-form-container .saplan-form-wrapper {
    padding: 0.75rem;
  }
  .saplan-form-container .saplan-form-header .saplan-form-title {
    font-size: 1.125rem;
  }
  .saplan-form-container .form-group input,
  .saplan-form-container .form-group select,
  .saplan-form-container .form-group textarea {
    padding: 0.375rem;
    font-size: 0.8125rem;
  }
  .saplan-form-container button[type=submit] {
    padding: 0.5rem 1rem;
    font-size: 0.8125rem;
  }
  .saplan-form-container .rights-checkboxes {
    grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
    gap: 0.5rem;
  }
}
@media print {
  .saplan-form-container {
    background: white;
    padding: 0;
  }
  .saplan-form-container .saplan-form-wrapper {
    box-shadow: none;
    border: 1px solid #000;
  }
  .saplan-form-container button,
  .saplan-form-container .toast {
    display: none;
  }
}
.saplan-form-container input:focus-visible,
.saplan-form-container select:focus-visible,
.saplan-form-container textarea:focus-visible,
.saplan-form-container button:focus-visible {
  outline: 2px solid var(--primary-color, #3b82f6);
  outline-offset: 2px;
}
.saplan-form-container .checkbox-group input[type=checkbox]:focus-visible {
  outline: 2px solid var(--primary-color, #3b82f6);
  outline-offset: 2px;
}`, "",{"version":3,"sources":["webpack://./src/forms/SAPlanForm/SAPlanForm.scss"],"names":[],"mappings":"AACA;EACE,+BAAA;EACA,mCAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;AAAF;AAEE;EATF;IAUI,aAAA;EACF;AACF;AAAE;;EAEA,wBAAA;EACA,SAAA;AAEF;AAEE;EACE,eAAA;EACA,SAAA;EACA,WAAA;EACA,qBAAA;EACA,uBAAA;EACA,YAAA;EACA,gBAAA;EACA,aAAA;EACA,uCAAA;AAAJ;AAEI;EACE,yBAAA;AAAN;AAGI;EACE,yBAAA;AADN;AAME;EACE,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,wCAAA;EACA,0CAAA;EACA,UAAA;AAJJ;AAMI;EATF;IAUI,aAAA;IACA,WAAA;EAHJ;AACF;AAOE;EACE,kBAAA;EACA,qBAAA;AALJ;AAOI;EACE,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;AALN;AAOM;EANF;IAOI,kBAAA;EAJN;AACF;AASE;EACE,YAAA;EACA,6BAAA;EACA,gBAAA;AAPJ;AAWE;EACE,UAAA;EACA,uBAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,WAAA;AATJ;AAWI;EARF;IASI,UAAA;IACA,WAAA;EARJ;AACF;AAYE;EACE,aAAA;AAVJ;AAcE;EAEE,sBAAA;AAbJ;AAeI;EACE,mBAAA;EACA,gBAAA;EACA,iBAAA;AAbN;AAgBI;EACE,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,gCAAA;AAdN;AAmBE;EACE,aAAA;EACA,SAAA;EACA,mBAAA;AAjBJ;AAmBI;EACE,gBAAA;AAjBN;AAoBI;EATF;IAUI,sBAAA;IACA,WAAA;EAjBJ;AACF;AAqBE;EACE,SAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AAnBJ;AAqBI;EACE,gBAAA;AAnBN;AAsBI;EACE,cAAA;EACA,qBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;AApBN;AAqBM;EACE,cAAA;EACA,oBAAA;AAnBR;AAwBI;;;EAGE,WAAA;EACA,eAAA;EACA,yBAAA;EACA,sBAAA;EACA,mBAAA;EACA,oBAAA;EACA,cAAA;EACA,mBAAA;EACA,sBAAA;EACA,kBAAA;AAtBN;AAwBM;;;EACE,aAAA;EACA,2CAAA;EACA,6CAAA;AApBR;AAuBM;;;EACE,qBAAA;AAnBR;AAsBM;;;EACE,cAAA;AAlBR;AAqBM;;;EACE,yBAAA;EACA,cAAA;EACA,mBAAA;AAjBR;AAqBI;EACE,gBAAA;EACA,yDAAA;EACA,wCAAA;EACA,4BAAA;EACA,8BAAA;EACA,qBAAA;AAnBN;AAsBI;EACE,iBAAA;EACA,gBAAA;EACA,eAAA;AApBN;AAuBI;EACE,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;AArBN;AA0BE;EACE,aAAA;EACA,4DAAA;EACA,SAAA;EACA,gBAAA;AAxBJ;AA0BI;EANF;IAOI,4DAAA;IACA,YAAA;EAvBJ;AACF;AA0BE;EACE,aAAA;EACA,sBAAA;EACA,WAAA;AAxBJ;AA0BI;EACE,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,0BAAA;EACA,gBAAA;EACA,eAAA;AAxBN;AA4BI;EACE,gBAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;EACA,gBAAA;AA1BN;AA4BM;EACE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;EACA,QAAA;EACA,uBAAA;EACA,kBAAA;EACA,yBAAA;EACA,wCAAA;AA1BR;AA6BM;EACE,+CAAA;AA3BR;AA6BQ;EACE,2BAAA;AA3BV;AA+BM;EACE,aAAA;EACA,6CAAA;AA7BR;AAgCM;EACE,yBAAA;AA9BR;AAiCM;EACE,yBAAA;AA/BR;AAqCE;EACE,WAAA;EACA,uBAAA;EACA,sCAAA;EACA,YAAA;EACA,YAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;AAnCJ;AAqCI;EACE,aAAA;AAnCN;AAqCI;EACE,yBAAA;AAnCN;AAsCI;EACE,yBAAA;EACA,cAAA;EACA,mBAAA;EACA,YAAA;AApCN;AAuCI;EA5BF;IA6BI,yBAAA;IACA,oBAAA;EApCJ;AACF;AAwCE;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,mBAAA;EACA,cAAA;AAtCJ;;AA2CA;EACE;IACE,UAAA;IACA,2BAAA;EAxCF;EA2CA;IACE,UAAA;IACA,wBAAA;EAzCF;AACF;AA4CA;EACE;IACE,UAAA;IACA,2BAAA;EA1CF;EA6CA;IACE,UAAA;IACA,wBAAA;EA3CF;AACF;AA+CA;EAEI;IACE,WAAA;EA9CJ;AACF;AAkDA;EACE;IACE,eAAA;EAhDF;EAkDE;IACE,gBAAA;EAhDJ;EAoDI;IACE,mBAAA;EAlDN;EAuDI;;;IAGE,iBAAA;IACA,oBAAA;EArDN;EAyDE;IACE,oBAAA;IACA,oBAAA;EAvDJ;EA0DE;IACE,4DAAA;IACA,WAAA;EAxDJ;AACF;AA6DA;EACE;IACE,iBAAA;IACA,UAAA;EA3DF;EA6DE;IACE,gBAAA;IACA,sBAAA;EA3DJ;EA8DE;;IAEE,aAAA;EA5DJ;AACF;AAkEE;;;;EAIE,gDAAA;EACA,mBAAA;AAhEJ;AAmEE;EACE,gDAAA;EACA,mBAAA;AAjEJ","sourcesContent":["// Main Container\r\n.saplan-form-container {\r\n  min-height: calc(100vh - 118px);\r\n  background: var(--grey-shade-three);\r\n  padding: 2rem;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  align-items: center;\r\n\r\n  @media (max-width: 768px) {\r\n    padding: 1rem;\r\n  }\r\n  .no-spinner::-webkit-outer-spin-button,\r\n.no-spinner::-webkit-inner-spin-button {\r\n  -webkit-appearance: none;\r\n  margin: 0;\r\n}\r\n\r\n  // Toast styling (if you add toast functionality later)\r\n  .toast {\r\n    position: fixed;\r\n    top: 1rem;\r\n    right: 1rem;\r\n    padding: 0.75rem 1rem;\r\n    border-radius: 0.375rem;\r\n    color: white;\r\n    font-weight: 500;\r\n    z-index: 1000;\r\n    animation: toast-slide-in 0.3s ease-out;\r\n\r\n    &.success {\r\n      background-color: #10b981;\r\n    }\r\n\r\n    &.error {\r\n      background-color: #ef4444;\r\n    }\r\n  }\r\n\r\n  // Form Wrapper - New wrapper structure\r\n  .saplan-form-wrapper {\r\n    background: #ffffff;\r\n    border: 1px solid #e5e7eb;\r\n    border-radius: 8px;\r\n    padding: 1.5rem;\r\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\r\n    animation: plan-form-fade-in 0.3s ease-out;\r\n    width: 70%;\r\n\r\n    @media (max-width: 768px) {\r\n      padding: 1rem;\r\n      width: 100%;\r\n    }\r\n  }\r\n\r\n  // Header styling (moved inside wrapper)\r\n  .saplan-form-header {\r\n    text-align: center;\r\n    margin-bottom: 0.5rem;\r\n\r\n    .saplan-form-title {\r\n      font-size: 1.6rem;\r\n      font-weight: 500;\r\n      color: #374151;\r\n      margin: 0;\r\n\r\n      @media (max-width: 768px) {\r\n        font-size: 1.25rem;\r\n      }\r\n    }\r\n  }\r\n\r\n  // Divider styling\r\n  .saplan-form-divider {\r\n    border: none;\r\n    border-top: 1px solid #e5e7eb;\r\n    margin: 1.5rem 0;\r\n  }\r\n\r\n  // Form styling - Updated to work with wrapper\r\n  form {\r\n    padding: 0; // Remove padding since it's now in wrapper\r\n    background: transparent;\r\n    border: none;\r\n    box-shadow: none;\r\n    animation: none;\r\n    width: 100%;\r\n\r\n    @media (max-width: 768px) {\r\n      padding: 0;\r\n      width: 100%;\r\n    }\r\n  }\r\n\r\n  // Hide old h1 outside wrapper (if any remains)\r\n  > h1 {\r\n    display: none;\r\n  }\r\n\r\n  // Form sections for better organization\r\n  .form-section {\r\n    //margin-bottom: 1.5rem;\r\n    padding-bottom: 1.5rem;\r\n\r\n    &:last-of-type {\r\n      border-bottom: none;\r\n      margin-bottom: 0;\r\n      padding-bottom: 0;\r\n    }\r\n\r\n    h3 {\r\n      font-size: 1.125rem;\r\n      font-weight: 500;\r\n      color: #374151;\r\n      margin: 0 0 1rem 0;\r\n      padding-bottom: 0.5rem;\r\n      border-bottom: 1px solid #e5e7eb;\r\n    }\r\n  }\r\n\r\n  // Form rows for side-by-side layout\r\n  .form-row {\r\n    display: flex;\r\n    gap: 1rem;\r\n    margin-bottom: 1rem;\r\n\r\n    &:last-child {\r\n      margin-bottom: 0;\r\n    }\r\n\r\n    @media (max-width: 768px) {\r\n      flex-direction: column;\r\n      gap: 0.5rem;\r\n    }\r\n  }\r\n\r\n  // Individual form groups\r\n  .form-group {\r\n    flex: 1;\r\n    display: flex;\r\n    flex-direction: column;\r\n    margin-bottom: 0rem;\r\n\r\n    &:last-child {\r\n      margin-bottom: 0;\r\n    }\r\n\r\n    label {\r\n      display: block;\r\n      margin-bottom: 0.5rem;\r\n      font-weight: 500;\r\n      font-size: 0.875rem;\r\n      color: #374151;\r\n      .saplan-form-required {\r\n        color: #ef4444;\r\n        margin-left: 0.25rem;\r\n      }\r\n    }\r\n\r\n    // Input styling to match UserForm\r\n    input,\r\n    select,\r\n    textarea {\r\n      width: 100%;\r\n      padding: 0.5rem;\r\n      border: 1px solid #d1d5db;\r\n      border-radius: 0.25rem;\r\n      font-size: 0.875rem;\r\n      font-family: inherit;\r\n      color: #374151;\r\n      background: #ffffff;\r\n      box-sizing: border-box;\r\n      min-height: 2.5rem;\r\n\r\n      &:focus {\r\n        outline: none;\r\n        border-color: var(--primary-color, #3b82f6);\r\n        box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\r\n      }\r\n\r\n      &:hover:not(:focus) {\r\n        border-color: #9ca3af;\r\n      }\r\n\r\n      &::placeholder {\r\n        color: #9ca3af;\r\n      }\r\n\r\n      &:disabled {\r\n        background-color: #f9fafb;\r\n        color: #6b7280;\r\n        cursor: not-allowed;\r\n      }\r\n    }\r\n\r\n    select {\r\n      appearance: none;\r\n      background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%236b7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='m6 8 4 4 4-4'/%3e%3c/svg%3e\");\r\n      background-position: right 0.5rem center;\r\n      background-repeat: no-repeat;\r\n      background-size: 1.5rem 1.5rem;\r\n      padding-right: 2.5rem;\r\n    }\r\n\r\n    textarea {\r\n      min-height: 100px;\r\n      resize: vertical;\r\n      padding: 0.5rem;\r\n    }\r\n\r\n    .error {\r\n      color: #ef4444;\r\n      font-size: 0.75rem;\r\n      margin-top: 0.25rem;\r\n      font-weight: 500;\r\n    }\r\n  }\r\n\r\n  // Rights section styling to match visibility toggles\r\n  .rights-checkboxes {\r\n    display: grid;\r\n    grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));\r\n    gap: 1rem;\r\n    margin-top: 1rem;\r\n\r\n    @media (max-width: 768px) {\r\n      grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));\r\n      gap: 0.75rem;\r\n    }\r\n  }\r\n\r\n  .checkbox-group {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 0.5rem;\r\n\r\n    label {\r\n      font-size: 0.875rem;\r\n      font-weight: 500;\r\n      color: #374151;\r\n      text-transform: capitalize;\r\n      margin-bottom: 0;\r\n      cursor: pointer;\r\n    }\r\n\r\n    // Custom checkbox styling to match toggle switches\r\n    input[type=\"checkbox\"] {\r\n      appearance: none;\r\n      width: 50px;\r\n      height: 24px;\r\n      background-color: #d1d5db;\r\n      border: none;\r\n      border-radius: 24px;\r\n      position: relative;\r\n      cursor: pointer;\r\n      transition: all 0.3s ease;\r\n      min-height: 24px;\r\n\r\n      &::before {\r\n        content: \"\";\r\n        position: absolute;\r\n        height: 18px;\r\n        width: 18px;\r\n        left: 3px;\r\n        top: 3px;\r\n        background-color: white;\r\n        border-radius: 50%;\r\n        transition: all 0.3s ease;\r\n        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);\r\n      }\r\n\r\n      &:checked {\r\n        background-color: var(--primary-color, #3b82f6);\r\n\r\n        &::before {\r\n          transform: translateX(26px);\r\n        }\r\n      }\r\n\r\n      &:focus {\r\n        outline: none;\r\n        box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\r\n      }\r\n\r\n      &:hover:not(:checked) {\r\n        background-color: #9ca3af;\r\n      }\r\n\r\n      &:hover:checked {\r\n        background-color: #2563eb;\r\n      }\r\n    }\r\n  }\r\n\r\n  // Submit button styling to match UserForm\r\n  button[type=\"submit\"] {\r\n    width: 100%;\r\n    padding: 0.75rem 1.5rem;\r\n    background-color: var(--primary-color);\r\n    color: white;\r\n    border: none;\r\n    border-radius: 0.375rem;\r\n    font-weight: 500;\r\n    font-size: 0.875rem;\r\n    cursor: pointer;\r\n    transition: all 0.2s ease;\r\n    margin-top: 1.5rem;\r\n    min-height: 2.75rem;\r\n\r\n    &:focus {\r\n      outline: none;\r\n    }\r\n    &:hover {\r\n      background-color: #005a9a;\r\n    }\r\n\r\n    &:disabled {\r\n      background-color: #d1d5db;\r\n      color: #9ca3af;\r\n      cursor: not-allowed;\r\n      opacity: 0.6;\r\n    }\r\n\r\n    @media (max-width: 768px) {\r\n      padding: 0.625rem 1.25rem;\r\n      font-size: 0.8125rem;\r\n    }\r\n  }\r\n\r\n  // Loading state\r\n  .loading {\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    min-height: 200px;\r\n    font-size: 1.125rem;\r\n    color: #6b7280;\r\n  }\r\n}\r\n\r\n// Animations\r\n@keyframes plan-form-fade-in {\r\n  from {\r\n    opacity: 0;\r\n    transform: translateY(10px);\r\n  }\r\n\r\n  to {\r\n    opacity: 1;\r\n    transform: translateY(0);\r\n  }\r\n}\r\n\r\n@keyframes toast-slide-in {\r\n  from {\r\n    opacity: 0;\r\n    transform: translateX(100%);\r\n  }\r\n\r\n  to {\r\n    opacity: 1;\r\n    transform: translateX(0);\r\n  }\r\n}\r\n\r\n// Responsive design improvements\r\n@media (max-width: 768px) {\r\n  .saplan-form-container {\r\n    .saplan-form-wrapper {\r\n      width: 100%;\r\n    }\r\n  }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n  .saplan-form-container {\r\n    padding: 0.5rem;\r\n\r\n    .saplan-form-wrapper {\r\n      padding: 0.75rem;\r\n    }\r\n\r\n    .saplan-form-header {\r\n      .saplan-form-title {\r\n        font-size: 1.125rem;\r\n      }\r\n    }\r\n\r\n    .form-group {\r\n      input,\r\n      select,\r\n      textarea {\r\n        padding: 0.375rem;\r\n        font-size: 0.8125rem;\r\n      }\r\n    }\r\n\r\n    button[type=\"submit\"] {\r\n      padding: 0.5rem 1rem;\r\n      font-size: 0.8125rem;\r\n    }\r\n\r\n    .rights-checkboxes {\r\n      grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));\r\n      gap: 0.5rem;\r\n    }\r\n  }\r\n}\r\n\r\n// Print styles\r\n@media print {\r\n  .saplan-form-container {\r\n    background: white;\r\n    padding: 0;\r\n\r\n    .saplan-form-wrapper {\r\n      box-shadow: none;\r\n      border: 1px solid #000;\r\n    }\r\n\r\n    button,\r\n    .toast {\r\n      display: none;\r\n    }\r\n  }\r\n}\r\n\r\n// Focus visible improvements for accessibility\r\n.saplan-form-container {\r\n  input:focus-visible,\r\n  select:focus-visible,\r\n  textarea:focus-visible,\r\n  button:focus-visible {\r\n    outline: 2px solid var(--primary-color, #3b82f6);\r\n    outline-offset: 2px;\r\n  }\r\n\r\n  .checkbox-group input[type=\"checkbox\"]:focus-visible {\r\n    outline: 2px solid var(--primary-color, #3b82f6);\r\n    outline-offset: 2px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
